(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'app/urls', 'app/applicationUtils', 'app/wizard/eregWorkflowConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('jquery'), require('./../urls'), require('./../applicationUtils'), require('./../wizard/eregWorkflowConfigService'));
  } else {
    throw new Error('Only AMD and CommonJS imports are supported.');
  }
}(this, function($, urls, applicationUtils, eregWorkflowConfigService) {
  'use strict';

  /**
   * Logs out the user on the server
   *
   * @method logoutOnServer
   * @return {Promise} resolves when user is logged out on the server
   * @private
   */
  function logoutOnServer() {
    var deferred = $.Deferred();
    $.ajax({
      method: 'POST',
      url: urls.portalAuthenticationExtService + '/logout',
      data: '{}',
      dataType: 'json',
      contentType: 'application/json;charset=utf-8'
    })
    .always(function() {
      // lie and say the logout was always successful because the ajax promise rejects on 200
      deferred.resolve();
    });
    return deferred.promise();
  }

  /**
   * Contains utilities for logging users out of ereg.
   *
   * @class LogoutUtils
   */
  return {
    /**
     * Logs out the user by redirecting to the logout page
     * User will be directed to the login page based on the current app
     *
     * @method logoutWithRedirect
     */
    logoutWithRedirect: function() {
      window.location.href = applicationUtils.currentApplication.logoutUrl;
    },

    /**
     * Logs out the user by redirecting to the logout page
     * User will be redirected to portal login page
     *
     * @method logoutWithRedirectToPortal
     */
    logoutWithRedirectToPortal: function() {
      window.location.href = applicationUtils.APPLICATIONS.PATIENT_PORTAL.logoutUrl;
    },

    /**
     * Logs out the staff user by redirecting to the logout page
     * User will be redirected to ereg patient login page
     *
     * @method staffLogoutWithRedirectToEreg
     */
    staffLogoutWithRedirectToEreg: function() {
      window.location.href = applicationUtils.APPLICATIONS.EREG.logoutUrl;
    },

    /**
     * Logs out the patient by redirecting to the logout page
     * Patient will be redirected to ereg patient login page
     *
     * @method patientLogoutWithRedirectToEreg
     */
    patientLogoutWithRedirectToEreg: function() {
      eregWorkflowConfigService.removeEregWorkflowConfig();
      window.location.href = applicationUtils.APPLICATIONS.EREG.logoutUrl;
    },

    /**
     * Logs out the user by sending request to server and refreshing page
     * User will remain on same page
     *
     * @method logoutInPlace
     */
    logoutInPlace: function logoutInPlace() {
      logoutOnServer()
      .then(function() {
        window.location.reload();
      });
    }
  };
}));
